<div class="p-6">
  <h2 class="text-2xl font-bold mb-4">Users Management</h2>

  <!-- Search Bar -->
  <div class="flex mb-4">
    <input [(ngModel)]="searchText" (keyup.enter)="search()"
           type="text" placeholder="Search by email or role..."
           class="flex-1 p-2 border rounded-md focus:ring focus:ring-blue-200" />
    <button (click)="search()" class="ml-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
      Search
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="text-center">
    <p class="text-gray-500">Loading users...</p>
  </div>

  <!-- Users Table -->
  <div *ngIf="!loading && users.length > 0" class="overflow-x-auto">
    <table class="min-w-full bg-white border rounded-lg shadow">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="py-2 px-4">Email</th>
          <th class="py-2 px-4">Role</th>
          <th class="py-2 px-4">Status</th>
          <th class="py-2 px-4">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users" class="border-t">
          <td class="py-2 px-4">{{ user.email }}</td>
          <td class="py-2 px-4">
            <select [(ngModel)]="user.role"
                    (change)="changeRole(user, user.role)"
                    class="p-1 border rounded-md">
              <option value="Admin">Admin</option>
              <option value="Vendor">Vendor</option>
              <option value="Customer">Customer</option>
            </select>
          </td>
          <td class="py-2 px-4">
            <span [ngClass]="user.isActive ? 'text-green-600' : 'text-red-600'">
              {{ user.isActive ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td class="py-2 px-4 space-x-2">
            <button (click)="toggleActive(user)"
                    class="px-3 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600">
              {{ user.isActive ? 'Deactivate' : 'Activate' }}
            </button>
            <button (click)="deleteUser(user)"
                    class="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="!loading && users.length === 0" class="text-gray-500 mt-4">
    No users found.
  </p>
</div>
